import { ursaColors } from "@smartsheet/design-tokens";
import { themed } from "../../../util/theme";
import { BaseButtonStyledProps } from "../types";

export const getButtonBorder = (props: BaseButtonStyledProps) => {
    if (props.appearance === "secondary-outlined") {
        const color = props.state.isFocus ? ursaColors.neutral200 : ursaColors.neutral300;
        return `1px solid ${color};`;
    } else {
        // Since some buttons use a border, we'll add a transparent border to all buttons by
        // default. This helps our focus ring code to have a consistent target radius.
        return `1px solid transparent`;
    }
};

const underlineOffset = themed({
    "lodestar-light": "1px",
    "ursa-light": "2px",
});

export const getUnderlineOffset = ({ themeMode }: BaseButtonStyledProps): string => {
    return underlineOffset(themeMode);
};
